import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import {
  FormModeEnum,
  NotificationService,
  ModalService,
  BackendService,
  TableActionParams,
} from 'beyond-util';

import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-ciljne-grupe',
  templateUrl: './ciljne-grupe.component.html',
})
export class CiljneGrupeComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;
  public showDetails = false;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSOP_CG,
          FormName.SifarnikCiljnihGrupa,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.setSettings(data['Settings']);
          }
          this._data = data['ServiceData']['Data'];
          this.setId(this._data);
          this.orderList = this.setRbr([...this._data]);
          this.setAllFields();
        })
    );
  }

  addOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSOP_CG, FormName.SifarnikCiljnihGrupa, payload)
        .subscribe(data => {
          this.getServiceErrorMessage(data);
          this.loadSettings();
        })
    );
  }

  getServiceErrorMessage(data) {
    if (data['Error'] && data['Error']['ErrorMessage']) {
      this._notificationService.notyError(data['Error']['ErrorMessage']);

      return;
    }
  }

  updateOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSOP_CG, FormName.SifarnikCiljnihGrupa, payload)
        .subscribe(data => {
          this.getServiceErrorMessage(data);
          this.loadSettings();
        })
    );
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSOP_CG, FormName.SifarnikCiljnihGrupa, this.order.Id)
        .subscribe(() => {
          this.loadSettings();
          this._notificationService.openNoty('Uspešno brisanje');
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.updateOrder();
  }

  onTableInlineSave(event) {
    this.addOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/ciljne-grupe/ciljne-grupe.component.ts